"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
const Project = props => /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
  width: 16,
  height: 16,
  viewBox: "0 0 66 70"
}, props), /*#__PURE__*/_react.default.createElement("path", {
  d: "M64.445 17.578a4.977 4.977 0 0 0-1.932-1.893L35.004.625a4.981 4.981 0 0 0-4.8 0l-27.5 15.056a4.978 4.978 0 0 0-1.931 1.894 5 5 0 0 0-.669 2.482v29.887a5 5 0 0 0 2.6 4.375l27.5 15.053a4.962 4.962 0 0 0 4.8 0l27.5-15.053a5 5 0 0 0 2.6-4.375V20.056a5 5 0 0 0-.66-2.478zm-34.341 46.05-10-5.475V42.5a2.5 2.5 0 0 0-1.3-2.187l-13.7-7.5v-10l25 13.687v27.128zm2.5-31.478L7.81 18.575l10.775-5.897 12.813 7.016a2.5 2.5 0 0 0 2.4 0l12.812-7.016 10.775 5.897L32.604 32.15zm27.5.657-13.7 7.5a2.5 2.5 0 0 0-1.3 2.187v15.653l-10 5.475v-27.14l25-13.688v10.012z",
  className: "fill"
}));
var _default = exports.default = Project;